<template>
  <button class="start-btn" @click="handleCreateWork">
    免费试用
    <ArrowRight class="text-[22px]" filled />
  </button>
</template>

<script lang="ts" setup>
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
const handleCreateWork = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped>
.start-btn {
  @apply flex gap-3 items-center justify-center;
  line-height: 28px;
  padding: 15px 48px;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  background-color: var(--x-text-1);
  color: var(--x-white-1);
  font-size: 20px;
  transition: all 0.3s ease;

  &:hover {
    background-color: var(--x-text-3);
  }
}
</style>
